type SpinIconProps = {
  loading?: boolean;
  speed: "slow" | "fast";
  color?: string;
};

const SpinIcon = ({
  loading,
  speed = "slow",
  color = "oklch(54.6% 0.245 262.881)",
}: SpinIconProps) => {
  return (
    <svg
      className={`w-5 h-5 ${loading ? "animate-spin" : ""}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      style={{ animationDuration: speed === "slow" ? "1.5s" : "0.5s" }}
    >
      <path
        color={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </svg>
  );
};

export default SpinIcon;
